module.exports = __webpack_public_path__ + "img/Incendio.0c7839b9.svg";